export const CPF_REGEX_PLAIN = /^\d{11}$/;
export const CPF_REGEX_FORMATTED = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
export const CPF_REGEX_BOTH = /^(?:\d{11}|\d{3}\.\d{3}\.\d{3}-\d{2})$/;

export function isValidCPF(input) {
  if (!input) return false;
  const cpf = String(input).replace(/\D/g, '');
  if (cpf.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(cpf)) return false;

  const calcDigit = (sliceEnd) => {
    let sum = 0;
    for (let i = 0; i < sliceEnd; i++) {
      sum += parseInt(cpf.charAt(i), 10) * (sliceEnd + 1 - i);
    }
    const mod = sum % 11;
    return mod < 2 ? 0 : 11 - mod;
  };

  const d1 = calcDigit(9);
  const d2 = calcDigit(10);
  return d1 === parseInt(cpf.charAt(9), 10) && d2 === parseInt(cpf.charAt(10), 10);
}
